export default __webpack_public_path__ + "static/media/la_child.fce3f157.svg";